/*******************************************
 * Slider Stuff *
 * We are using slickslider to handle all sliders *
 *******************************************/

jQuery(document).ready(function($) {


  if ( $('.flex-content.tabbed-content').length ){
        $('.tab-content').slick({
          infinite: true,
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.tab-nav'
        });

        $('.tab-nav').slick({
          infinite: true,
          slidesToShow: 8,
          slidesToScroll: 1,
          asNavFor: '.tab-content',
          focusOnSelect: true,
          //arrows: false,
          prevArrow: $('.tab-arrow-prev'),
          nextArrow: $('.tab-arrow-next'),
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
   }

   if ( $('.insights-tabs.tabbed-content').length ){
        $('.tab-content').slick({
          infinite: true,
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.tab-nav'
        });

        $('.tab-nav').slick({
          infinite: true,
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: '.tab-content',
          focusOnSelect: true,
          //arrows: false,
          prevArrow: $('.tab-arrow-prev'),
          nextArrow: $('.tab-arrow-next'),
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        });
   }

       

   if ( $('.gallery-images').find('.image-slide').length > 4 ){
      $('.gallery-images').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        variableHeight: true,
        prevArrow: $('.gallery-arrow-prev'),
        nextArrow: $('.gallery-arrow-next'),
      });
   }


   if ( $('.testimonial-list').length ){
    $('.testimonial-list').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      prevArrow: $('.test-arrow-prev'),
      nextArrow: $('.test-arrow-next'),
      variableHeight: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });    
    
    // Find the tallest testimonial
    var maxHeight = 0;

    $('.testimonial-content').each(function() {
      var height = $(this).height();
      maxHeight = height > maxHeight ? height : maxHeight;
    });

    // Set the same height for all testimonials
    $('.testimonial-content').height(maxHeight);
}

});
